import { shippingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import { css } from "styled-components";

shippingAddressStyles.addressBookModal = {
    sizeVariant: "medium",
    cssOverrides: {
        modalContent: css`
            > div[class^="ToolbarStyled"] {
                > div[class^="FormFieldStyle"] {
                    > div[class^="FormInputWrapper"] {
                        span[class^="IconWrapper"] {
                            position: absolute;
                            box-sizing: border-box;
                            top: 2px;
                            right: 2px;
                            width: 36px;
                            height: 36px;
                            padding: 8px;
                            border-radius: 100%;
                            pointer-events: none;
                        }
                    }
                }
            }
        `,
    },
}